document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.nav-standard [data-nav-main], [data-nav-main].nav-standard');

  if (!nav || window.matchMedia('(max-width: 1023px)').matches) {
    return;
  }

  const header = nav.closest('[data-header-height]') || document.querySelector('[data-header-height]');
  const dropdownParents = nav.querySelectorAll('[data-dropdown-parent]');

  if (!dropdownParents.length) {
    return;
  }

  const syncHeaderState = () => {
    if (!header) {
      return;
    }

    const hasExpandedMegaMenu = nav.querySelector('.menu-item--meganav.is-expanded');
    header.classList.toggle('header--megamenu-visible', Boolean(hasExpandedMegaMenu));
  };

  const setExpandedState = (dropdownParent, isExpanded) => {
    const trigger = dropdownParent.querySelector('[data-collapsible-trigger]');
    const visibleNavLinks = dropdownParent.querySelectorAll('[data-visible-link]');

    dropdownParent.classList.toggle('is-expanded', isExpanded);

    if (trigger) {
      trigger.setAttribute('aria-expanded', String(isExpanded));
    }

    visibleNavLinks.forEach((link) => {
      if (isExpanded) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }

      if (link.hasAttribute('aria-expanded')) {
        link.setAttribute('aria-expanded', String(isExpanded));
      }
    });
  };

  const closeOtherDropdowns = (currentDropdown) => {
    dropdownParents.forEach((dropdownParent) => {
      if (dropdownParent !== currentDropdown && dropdownParent.classList.contains('is-expanded')) {
        setExpandedState(dropdownParent, false);
      }
    });
  };

  dropdownParents.forEach((dropdownParent) => {
    dropdownParent.addEventListener('mouseenter', () => {
      closeOtherDropdowns(dropdownParent);
      setExpandedState(dropdownParent, true);
      syncHeaderState();
    });

    dropdownParent.addEventListener('mouseleave', () => {
      setExpandedState(dropdownParent, false);
      syncHeaderState();
    });
  });
});
